import React, { useEffect, useState } from "react";
import { Button, Table, Form, Row, Col, FloatingLabel } from "react-bootstrap";
import AddAsha from "../AddAsha";
import EditAsha from "../EditAsha";
import { Loading, AppPagination } from "../../components/Index";
import AlertModal from "../../../components/AlertModal";
import { AshaServices } from "../../../services/AshaService";
import { TalukServices } from "../../../services/Taluk";
import { PHCServices } from "../../../services/Phcs";
import { AshaBlockServices } from "../../../services/AshaBlocks";

function SuperAdminAshaView() {
  const [allAshaList, setAllAshaList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [addModalShow, setAddModalShow] = useState(false);
  const [selectedTaluk, setSelectedTaluk] = useState("");
  const [selectedPhc, setSelectedPhc] = useState("");
  const [selectedAshaBlock, setSelectedAshaBlock] = useState("");
  const [taluks, setTaluks] = useState([]);
  const [phcs, setPhcs] = useState([]);
  const [ablocks, setAblocks] = useState([]);
  const [allAshaBlocks, setAllAshaBlocks] = useState([]);
  const [pagination, setPagination] = useState({ cur: 1, max: 1 });
  const pageSize = 10;
  
  // Modal states
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [modalData, setModalData] = useState({});

  useEffect(() => {
    getAsha();
    getTaluks();
    getPhcs();
    getAllAshaBlocks();
  }, []);

  useEffect(() => {
    if (selectedTaluk) {
      const fetchPhcsByTaluk = async () => {
        try {
          const res = await PHCServices.gePhcsByTalukId(selectedTaluk);
          if (Array.isArray(res)) {
            setPhcs(res);
          } else if (res && typeof res === "object") {
            const values = Object.values(res);
            setPhcs(values.length > 0 && values[0].id ? values : []);
          } else {
            setPhcs([]);
          }
        } catch (error) {
          console.error("Failed to fetch PHCs for Taluk", error);
          setPhcs([]);
        }
      };
      fetchPhcsByTaluk();
    } else {
      setPhcs([]);
    }
  }, [selectedTaluk]);
  
  useEffect(() => {
    if (selectedPhc) {
      const fetchAshaBlocksByPhc = async () => {
        try {
          const res = await AshaBlockServices.geAshaBlockByPhcId(selectedPhc);
          if (Array.isArray(res)) {
            setAllAshaBlocks(res);
          } else if (res && typeof res === "object") {
            const values = Object.values(res);
            setAllAshaBlocks(values.length > 0 && values[0].id ? values : []);
          } else {
            setAllAshaBlocks([]);
          }
        } catch (error) {
          console.error("Failed to fetch AshaBlocks for PHC", error);
          setAllAshaBlocks([]);
        }
      };
      fetchAshaBlocksByPhc();
    } else {
      setAllAshaBlocks([]);
    }
  }, [selectedPhc]);

  const getTaluks = async () => {
    try {
      const res = await TalukServices.getAllTaluks();
      if (Array.isArray(res)) {
        setTaluks(res);
      } else if (res && typeof res === "object") {
        const values = Object.values(res);
        if (values.length > 0 && values[0].id) {
          setTaluks(values);
        } else {
          setTaluks([]);
        }
      } else {
        setTaluks([]);
      }
    } catch (error) {
      console.error("Failed to load Taluks", error);
      setTaluks([]);
    }
  };
  

  const getPhcs = async () => {
    try {
      const res = await PHCServices.getAllPhcs();
      if (Array.isArray(res)) {
        setPhcs(res);
      } else if (res && typeof res === "object") {
        const values = Object.values(res);
        if (values.length > 0 && values[0].id) {
          setPhcs(values);
        } else {
          setPhcs([]);
        }
      } else {
        setPhcs([]);
      }
    } catch (error) {
      console.error("Failed to load PHCs", error);
      setPhcs([]);
    }
  };
  
  const getAllAshaBlocks = async () => {
    try {
      const res = await AshaBlockServices.getAllAshaBlocks();
      if (Array.isArray(res)) {
        setAllAshaBlocks(res);
      } else if (res && typeof res === "object") {
        const values = Object.values(res);
        if (values.length > 0 && values[0].id) {
          setAllAshaBlocks(values);
        } else {
          setAllAshaBlocks([]);
        }
      } else {
        setAllAshaBlocks([]);
      }
    } catch (error) {
      console.error("Failed to load AshaBlocks", error);
      setAllAshaBlocks([]);
    }
  };

  const getAsha = async () => {
    setLoading(true);
    try {
      const res = await AshaServices.getAllAshas();
      if (Array.isArray(res)) {
        setAllAshaList(res);
      } else if (res && typeof res === "object") {
        const values = Object.values(res);
        if (values.length > 0 && values[0].id) {
          setAllAshaList(values);
        } else {
          setAllAshaList([]);
        }
      } else {
        setAllAshaList([]);
      }
    } catch (error) {
      console.error("Failed to fetch Asha", error);
      setAllAshaList([]);
    }
    setLoading(false);
  };

  const filteredAsha = allAshaList.filter((i) => {
    const matchesSearch =
      (i.name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (i.preDefinedAshaId || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (i.mobileNo || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (i.ashaBlockDetails?.phcDetails?.phc || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (i.ashaBlockDetails?.ashaBlock || "").toLowerCase().includes(searchTerm.toLowerCase());

    const matchesTaluk = !selectedTaluk || i.ashaBlockDetails?.phcDetails?.talukDetails?.id?.toString() === selectedTaluk;
    const matchesPhc = !selectedPhc || i.ashaBlockDetails?.phcDetails?.id?.toString() === selectedPhc;
    const matchesBlock = !selectedAshaBlock || i.ashaBlockDetails?.id?.toString() === selectedAshaBlock;

    return matchesSearch && matchesTaluk && matchesPhc && matchesBlock;
  });

  const paginatedAsha = filteredAsha.slice((pagination.cur - 1) * pageSize, pagination.cur * pageSize);
  const maxPages = Math.ceil(filteredAsha.length / pageSize);

  useEffect(() => {
    setPagination((prev) => ({ ...prev, max: maxPages }));
  }, [filteredAsha.length]);

  return (
    <>
      <Row className="mb-3">
        <Col>
          <FloatingLabel controlId="taluk" label="Taluk" className="mt-3">
            <Form.Select
              value={selectedTaluk}
              onChange={(e) => {
                setSelectedTaluk(e.target.value);
                setSelectedPhc("");
                setSelectedAshaBlock("");
              }}
            >
              <option value="" disabled hidden>Select</option>
              {taluks.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.taluk}
                </option>
              ))}
            </Form.Select>
          </FloatingLabel>
        </Col>

        <Col>
          <FloatingLabel controlId="phc" label="PHC" className="mt-3">
            <Form.Select
              value={selectedPhc}
              onChange={(e) => {
                setSelectedPhc(e.target.value);
                setSelectedAshaBlock("");
              }}
            >
              <option value="" disabled hidden>Select</option>
              {phcs
                .map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.phc}
                  </option>
                ))}
            </Form.Select>
          </FloatingLabel>
        </Col>

        <Col>
          <FloatingLabel controlId="ashaBlock" label="Asha Block" className="mt-3">
            <Form.Select
              value={selectedAshaBlock}
              onChange={(e) => setSelectedAshaBlock(e.target.value)}
            >
              <option value="" disabled hidden>Select</option>
              {allAshaBlocks
                .map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.ashaBlock}
                  </option>
                ))}
            </Form.Select>
          </FloatingLabel>
        </Col>

        <Col>
          <Form.Control
            type="text"
            placeholder="Search by Asha ID or Name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="mt-3"
          />
        </Col>

        <Col className="d-flex align-items-center justify-content-end mt-3">
          <Button className="custom-btn" onClick={() => setAddModalShow(true)}>
            Add Asha
          </Button>
        </Col>
      </Row>

      <AddAsha
        show={addModalShow}
        onHide={() => setAddModalShow(false)}
        onClose={() => getAsha()}
      />

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Sl no</th>
            <th>Asha Name</th>
            <th>Asha ID</th>
            <th>Mob no</th>
            <th>PHC</th>
            <th>Asha Block</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {!loading &&
            paginatedAsha.map((i, index) => (
              <tr key={i.id}>
                <td>{(pagination.cur - 1) * pageSize + index + 1}</td>
                <td>{i.name}</td>
                <td>{i.preDefinedAshaId}</td>
                <td>{i.mobileNo}</td>
                <td>{i.ashaBlockDetails?.phcDetails?.phc || "N/A"}</td>
                <td>{i.ashaBlockDetails?.ashaBlock || "N/A"}</td>
                <td>
                  <EditAsha asha={i} onClose={() => getAsha()} />
                </td>
              </tr>
            ))}
        </tbody>
      </Table>

      {paginatedAsha.length < 1 && !loading && (
        <h3 style={{ color: "#e77225", textAlign: "center" }}>No results found</h3>
      )}

      {loading && <Loading />}

      <div className="d-flex justify-content-center my-3">
        <AppPagination
          curPage={pagination.cur}
          maxPage={pagination.max}
          changePage={(page) => setPagination((prev) => ({ ...prev, cur: page }))}
        />
      </div>

      {/* Custom Modals */}
      <AlertModal
        show={showAlertModal}
        onHide={() => setShowAlertModal(false)}
        title={modalData.title}
        message={modalData.message}
        variant={modalData.variant}
      />
    </>
  );
}

export default SuperAdminAshaView;
